import styled from '@emotion/styled'
import decode from 'unescape'
import BandcampLink from './BandcampLink'
import ListItemContainer from './ListItemContainer'

const Image = styled.img`
  height: 3.25rem;
  width: 3.25rem;
`

const StyledBandcampLink = styled(BandcampLink)`
  bottom: ${({ theme }) => theme.space[1]};
  position: absolute;
  right: ${({ theme }) => theme.space[1]};
`

const EmbedTrack = ({ data, listId, play }) => {
  const { artist, image, label, title, url } = data
  const release = decode(`${artist} - ${title}`)

  return (
    <ListItemContainer onClick={play}>
      <div className="flex items-center w-100">
        <Image alt="cover art" className="mr2" src={image} />

        <div className="flex flex-column truncate">
          <div className="mb1 f6 truncate">
            {release.length <= 80 ? release : release.slice(0, 80) + '...'}
          </div>

          {label !== artist ? (
            <span className="gray f7 fw4 tracked-light">{decode(label)}</span>
          ) : null}
        </div>
      </div>

      <StyledBandcampLink className="hover-child" listId={listId} url={url} />
    </ListItemContainer>
  )
}

export default EmbedTrack
